import React from 'react'
import { useDispatch } from 'react-redux'
import Draggable from 'react-draggable'
import { actionSetActivePin, actionUpdatePinField } from '../../store/actions'

import './pin.css'

const PinComponent = (props) => {
  const { pin, index, wrapperDimension } = props
  const dispatch = useDispatch()
  const openPinOptionsPanel = () => {
    dispatch(actionSetActivePin(index))
  }
  const handleDragStop = (event, data) => {
    const top = (data.y + 15) / wrapperDimension.height * 100
    const left = (data.x + 15) / wrapperDimension.width * 100
    dispatch(actionUpdatePinField('top', `${top}%`, index))
    dispatch(actionUpdatePinField('left', `${left}%`, index))
  }
  const getDefaultPosition = () => {
    const wrapperWidth = wrapperDimension.width
    const wrapperHeight = wrapperDimension.height
    return {
      x: (parseFloat(pin.left) * wrapperWidth / 100) - 15,
      y: (parseFloat(pin.top) * wrapperHeight / 100) - 15
    }
  }
  const defaultPosition = getDefaultPosition()
  return (
    <Draggable
      bounds='.js-preview-mapper'
      handle='.pin'
      position={defaultPosition}
      onStop={handleDragStop}
    >
      <div className='pin' onClick={openPinOptionsPanel}>
        <span className='pin__name'>Pin #{index + 1}</span>
      </div>
    </Draggable>
  )
}

export default PinComponent
